import { FC } from 'react';
import { DataSourceOverviewCard } from './DataSourceOverviewCard';
import { DataSourceCardLabel } from './DataSourceCardLabel';

type TrackedEventsCardProps = {
  isLoading: boolean;
  trackedEvents: number;
};

export const TrackedEventsCard: FC<TrackedEventsCardProps> = ({ trackedEvents, isLoading }) => {
  return (
    <DataSourceOverviewCard title='overview.events_tracked' isLoading={isLoading}>
      <DataSourceCardLabel label={trackedEvents} />
    </DataSourceOverviewCard>
  );
};
